<template>
  <div>

    <table style="width: 100%">
      <thead>
        <tr>
          <my-header v-bind:h1="data.department" v-bind:h2="data.program" v-bind:h3="data.Name + ' ' + data.session" v-bind:h4="h2" v-bind:h5="h3"></my-header>
        </tr>
        <tr>
          <td colspan="3">
            <hr />
            <div v-html="data.Header"></div>
          </td>
        </tr>
      </thead>
      <tbody> 
        <tr>
          <td colspan="3"> 
            <table class="bg-grey table-collapse-12" border="1">
              <thead>
                <tr>
                  <th width="10px">Sr.</th>
                  <th>Form No</th>
                  <th>Name</th>
                  <th>Father Name</th>
                  <th>CNIC</th>
                  <th style="background-color: lightgray; color: black;" v-bind:width="widths" v-for="heading in data2">{{heading.Name}}</th>
                  <th width="7%" align="center">Merit</th>
                  <th width="7%" align="center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data.Students">
                  <td align="center">{{index + 1}}</td>
                  <td>{{item.FormNo}}</td>
                  <td>{{item.Name}} <span v-if="item.OverAge"> (Over Age)</span></td>
                  <td>{{item.FatherName}}</td>
                  <td style="white-space: nowrap">{{item.CNIC}}</td>
                  <td v-for="heading in data2" align="center">{{check(heading.typeID,heading.Percentage,heading.type,item.ProspectStudentID)}}</td>
                  <td align="right">{{item.Aggregate.toFixed(3)}}</td>
                  <td align="center">Recommended</td>
                </tr>
                <tr v-for="(item, index) in data.Waiting">
                  <td align="center">{{ data.Students.length + index + 1}}</td>
                  <td>{{item.FormNo}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.FatherName}}</td>
                  <td>{{item.CNIC}}</td>
                  <td v-for="heading in data2" align="center">{{checkWaiting(heading.typeID,heading.Percentage,heading.type,item.ProspectStudentID)}}</td>
                  <td align="right">{{item.Aggregate.toFixed(3)}}</td>
                  <td align="center">Waiting</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">
            <hr />
            <div v-html="data.Footer"></div>
          </td>
        </tr>
      </tfoot>
       
    </table>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        isupdate: false,
        data: '', data2: [], widths: '', EffectiveFrom: '', EffectiveTo: '', DepartmentContact: '',
        h2: '', h3: '',
      }
    },
    created: function () {
      this.loadTest();
    },
    methods:
    {
      loadTest() {
        var vm = this;
        axios.post('/api/AdmissionApi/MeritPrint')
          .then(function (res) {
            vm.data = res.data["test"];
            vm.data2 = res.data["cus"];
            vm.EffectiveTo = res.data.test.EffectiveTo;
            vm.DepartmentContact = res.data.test.DepartmentContact;
            vm.EffectiveFrom = res.data.test.EffectiveFrom;
            var value = (39 / vm.data2.length);
            vm.widths = value + "%";

            vm.h2 = "Effective From: " + res.data.test.EffectiveFrom + " To: " + res.data.test.EffectiveTo;
            vm.h3 = "For queries please contact on " + res.data.test.DepartmentContact;
          })
          .catch(function (res) {

          });
      },

      check(AggregateTypeID, Percentage, type, ProspectStudentID) {
        if (AggregateTypeID == 11) {
          var obj = this.data.entrytest.find(x => x.EntryTestID === AggregateTypeID && x.ProspectStudentID === ProspectStudentID);

          if (obj != null) {
            if (type == 1) {
              var value4 = obj.TotalMarks;
              return value4;
            }
            else if (type == 2) {
              var value5 = obj.MarksObtained;
              return value5;
            }
            else {
              var value6 = (Percentage * obj.MarksObtained) / obj.TotalMarks;
              return Math.round(value6);
            }


          }
          else
            return 0;
        }
        else {

          var obj1 = this.data.datas.find(x => x.EducationLevelID === AggregateTypeID && x.ProspectStudentID === ProspectStudentID);
          if (obj1 != null) {
            if (type == 1) {
              var value1 = obj1.TotalMarks;
              return value1;
            }
            else if (type == 2) {
              var value2 = obj1.ObtainedMarks;
              return value2;
            }
            else {
              var value3 = (Percentage * obj1.ObtainedMarks) / obj1.TotalMarks;
              return Math.round(value3);
            }


          }
          else
            return 0;
        }
      },

      checkWaiting(AggregateTypeID, Percentage, type, ProspectStudentID) {
        if (AggregateTypeID == 11) {
          var obj = this.data.waitingStudententrytest.find(x => x.EntryTestID === AggregateTypeID && x.ProspectStudentID === ProspectStudentID);

          if (obj != null) {
            if (type == 1) {
              var value4 = obj.TotalMarks;
              return value4;
            }
            else if (type == 2) {
              var value5 = obj.MarksObtained;
              return value5;
            }
            else {
              var value6 = (Percentage * obj.MarksObtained) / obj.TotalMarks;
              return Math.round(value6);
            }


          }
          else
            return 0;
        }
        else {

          var obj1 = this.data.waitingStudentEducation.find(x => x.EducationLevelID === AggregateTypeID && x.ProspectStudentID === ProspectStudentID);
          if (obj1 != null) {
            if (type == 1) {
              var value1 = obj1.TotalMarks;
              return value1;
            }
            else if (type == 2) {
              var value2 = obj1.ObtainedMarks;
              return value2;
            }
            else {
              var value3 = (Percentage * obj1.ObtainedMarks) / obj1.TotalMarks;
              return Math.round(value3);
            }


          }
          else
            return 0;
        }
      }

    }
  })
</script>
<style>
  td {
    padding-left: 3px;
  }

  th {
    padding-left: 8px;
    color: black;
    font-weight: 600;
    
  }
  tbody tr td{
    font-size:16px;
  }
</style>
<style>
  .bg {
    background-color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/meritListPrint.vue